// src/redux/notification/notificationApi.js
import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Get Notifications (paginated)
export const getNotificationsAPI = async ({
  page = 1,
  limit = 20,
  isRead,
  startDate,
  endDate,
} = {}) => {
  try {
    const params = { page, limit };
    if (isRead !== undefined) params.isRead = isRead;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await apiService.get(endpoints.getNotifications, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Unread Notification Count
export const getUnreadNotificationCountAPI = async () => {
  try {
    const response = await apiService.get(
      endpoints.getUnreadNotificationCount
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Mark Notification as Read
export const markNotificationAsReadAPI = async (notificationId) => {
  try {
    const endpoint = endpoints.markNotificationAsRead.replace(
      "{id}",
      notificationId
    );
    const response = await apiService.patch(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Mark All Notifications as Read
export const markAllNotificationsAsReadAPI = async () => {
  try {
    const response = await apiService.patch(
      endpoints.markAllNotificationsAsRead
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Notification
export const deleteNotificationAPI = async (notificationId) => {
  try {
    const endpoint = endpoints.deleteNotification.replace(
      "{id}",
      notificationId
    );
    const response = await apiService.delete(endpoint);
    return response.data;
  } catch (error) {
    throw error;
  }
};